import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { user, login, checked } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (checked && user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-charcoal text-ivory grid place-items-center relative overflow-hidden grain grain-dark" data-testid="admin-login-page" data-scope="admin">
      <div className="w-full max-w-md p-10 border border-[#333] bg-charcoal-surface relative">
        <Logo variant="light" />
        <div className="eyebrow text-gold mt-10">Admin</div>
        <h1 className="font-display text-4xl mt-2 leading-tight">Sign in to the practice desk.</h1>

        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="eyebrow text-[#9CA3AF]">Email</label>
            <input required type="email" className="input-flush !text-ivory !border-[#333] mt-1" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div>
            <label className="eyebrow text-[#9CA3AF]">Password</label>
            <input required type="password" className="input-flush !text-ivory !border-[#333] mt-1" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          <button disabled={busy} className="btn-primary btn-on-dark w-full" data-testid="admin-login-submit">
            {busy ? "…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
